let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '操作时间',
        props: 'createdWhen',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '操作内容',
        props: 'operationContent',
        minWidth: 200,
    },
    {
        label: '操作模块',
        props: 'operationModule',
        minWidth: 300,
    },
    {
        label: '操作人',
        props: 'operationUserAccount',
        minWidth: 300,
    },
  
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '系统管理'
},
{
    type: 'title',
    name: '操作记录'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
// pageConfig.tableEditObj = {
//     editKey: 'userId',
//     editRouter: 'userManageDetail',
// };

// 路由
pageConfig.listRouter = 'push_log_list';

// 详情的面包屑
// pageConfig.detailBreadCrumb = [{
//     type: 'title',
//     name: '首页',
// },
// {
//     type: 'router',
//     name: '用户管理',
//     router: 'user_list'
// },
// {
//     type: 'title',
//     name: '详情',
// }];

pageConfig.formRules = {
};



export default pageConfig;